/** Blocos que o rodapé pode ter. O conteúdo de cada um vem da loja, não é digitado de novo. */
export const THEME_FOOTER_BLOCKS = [
    { value: 'about', label: 'Sobre a loja' },
    { value: 'contact', label: 'Contato' },
    { value: 'pages', label: 'Páginas da loja' },
    { value: 'collections', label: 'Coleções' },
    { value: 'categories', label: 'Categorias' },
    { value: 'social', label: 'Redes sociais' },
    { value: 'newsletter', label: 'Newsletter' },
    { value: 'payments', label: 'Formas de pagamento' },
    { value: 'seals', label: 'Selos de segurança' },
    { value: 'apps', label: 'Aplicativo' },
];
/**
 * Rodapé. Os padrões desenham o rodapé de antes dos temas: disposição clássica, fundo
 * claro, sobre a loja, redes em texto e as páginas da loja.
 */
export const THEME_FOOTER_FIELDS = {
    layout: {
        type: 'select',
        label: 'Disposição',
        help: 'Na de uma linha só entram os links e as redes. Nas demais, todos os blocos.',
        options: [
            { value: 'classic', label: 'Clássica: loja à esquerda e redes à direita' },
            { value: 'minimal', label: 'Uma linha' },
            { value: 'centered', label: 'Centralizada' },
            { value: 'columns', label: 'Colunas' },
            { value: 'large', label: 'Rodapé grande' },
            { value: 'split', label: 'Dividido: a marca e a newsletter num painel, os links ao lado' },
            { value: 'wordmark', label: 'Marca em destaque: o nome da loja grande no fim' },
        ],
        default: 'classic',
    },
    background: {
        type: 'select',
        label: 'Fundo',
        options: [
            { value: 'light', label: 'Claro' },
            { value: 'primary', label: 'Cor principal' },
            { value: 'dark', label: 'Escuro' },
        ],
        default: 'light',
    },
    socialStyle: {
        type: 'select',
        label: 'Redes sociais',
        options: [
            { value: 'text', label: 'Nome da rede' },
            { value: 'icons', label: 'Ícone' },
        ],
        default: 'text',
    },
    blocks: {
        group: 'Blocos',
        type: 'list',
        label: 'Blocos do rodapé',
        help: 'Ordem de cima para baixo (ou da esquerda para a direita, em colunas).',
        max: 10,
        of: {
            kind: { type: 'select', label: 'Bloco', options: THEME_FOOTER_BLOCKS, default: 'pages' },
            title: { type: 'text', label: 'Título', help: 'Vazio: o nome do bloco.', maxLength: 40 },
            text: {
                type: 'text',
                label: 'Texto',
                help: 'Vazio: a descrição da loja.',
                multiline: true,
                maxLength: 400,
                visibleWhen: { field: 'kind', equals: 'about' },
            },
            newsletterText: {
                type: 'text',
                label: 'Chamada',
                maxLength: 160,
                default: 'Receba novidades e ofertas antes de todo mundo.',
                visibleWhen: { field: 'kind', equals: 'newsletter' },
            },
            sealImage: {
                type: 'image',
                label: 'Selo próprio (opcional)',
                help: 'Imagem de um selo que a loja tenha (ex.: certificação). Sem imagem: selo de site seguro.',
                visibleWhen: { field: 'kind', equals: 'seals' },
            },
            sealLink: { type: 'link', label: 'Link do selo', visibleWhen: { field: 'kind', equals: 'seals' } },
            appStore: { type: 'link', label: 'Link na App Store', visibleWhen: { field: 'kind', equals: 'apps' } },
            googlePlay: { type: 'link', label: 'Link no Google Play', visibleWhen: { field: 'kind', equals: 'apps' } },
        },
        default: [
            { kind: 'about', title: '', text: '' },
            { kind: 'social', title: '' },
            { kind: 'pages', title: '' },
        ],
    },
    showCompanyData: {
        group: 'Linha de baixo',
        type: 'toggle',
        label: 'Razão social, CNPJ e endereço',
        help: 'Vêm do cadastro da empresa. Obrigatório para loja virtual (Decreto 7.962/2013).',
        default: false,
    },
    benefitsEnabled: {
        group: 'Faixa de benefícios',
        type: 'toggle',
        label: 'Mostrar a faixa de benefícios acima do rodapé',
        default: false,
    },
    benefits: {
        group: 'Faixa de benefícios',
        type: 'list',
        label: 'Benefícios',
        max: 4,
        visibleWhen: { field: 'benefitsEnabled', equals: true },
        of: {
            icon: { type: 'icon', label: 'Ícone', default: 'truck' },
            title: { type: 'text', label: 'Título', maxLength: 40 },
            text: { type: 'text', label: 'Texto', maxLength: 80 },
        },
        default: [
            { icon: 'chat', title: 'Atendimento', text: 'Fale com a gente quando precisar.' },
            { icon: 'return', title: 'Trocas fáceis', text: 'Troca simples e sem burocracia.' },
            { icon: 'truck', title: 'Entrega garantida', text: 'Acompanhe o pedido até a sua casa.' },
            { icon: 'card', title: 'Parcele suas compras', text: 'Pix ou cartão, com segurança.' },
        ],
    },
    backToTop: {
        group: 'Botões flutuantes',
        type: 'toggle',
        label: 'Botão "voltar ao topo"',
        default: false,
    },
    whatsappFloat: {
        group: 'Botões flutuantes',
        type: 'toggle',
        label: 'Botão de WhatsApp no canto da tela',
        default: false,
    },
    whatsappNumber: {
        group: 'Botões flutuantes',
        type: 'text',
        label: 'Número do WhatsApp',
        help: 'Com DDD. Vazio: o WhatsApp das redes sociais da loja.',
        maxLength: 20,
        visibleWhen: { field: 'whatsappFloat', equals: true },
    },
    whatsappMessage: {
        group: 'Botões flutuantes',
        type: 'text',
        label: 'Mensagem inicial',
        maxLength: 200,
        default: 'Olá! Vim pela loja e gostaria de ajuda.',
        visibleWhen: { field: 'whatsappFloat', equals: true },
    },
};
//# sourceMappingURL=footer.js.map